import {SOPostPeriod} from '../../core/period/so-post-period';
import {PeriodCore} from './period.core';
import {SOGetPeriod} from '../../core/period/so-get-period';
import {FormField, SelectionOption} from 'lionheartland';
import {postPeriodFormFieldOptions} from './post-period-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {ProjectCore} from '../project/project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostPeriod extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postPeriodFormFieldOptions);

  RequestClass = SOPostPeriod

  constructor(
    public entityCore: PeriodCore
  ) {
    super();
    if (postPeriodFormFieldOptions.parent) {
      postPeriodFormFieldOptions.parent.makeCore = true;
    }
    if (postPeriodFormFieldOptions.project) {
      postPeriodFormFieldOptions.project.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier('numeral'),
      this.getFormValueFromIdentifier('type'),
      this.getFormValueFromIdentifier(
        'project',
        SOGetProject,
      ),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier(
        'parent',
        SOGetPeriod,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}